import Vue from 'vue';
import paba from './paba/paba.vue';
Vue.component('paba', paba);
